@if ($search()?.enabled) {
  <div class="settings-menu-search" [class.settings-menu-search-borderless]="$isCommandPalette()">
    @if (!$isCommandPalette()) {
      <i class="settings-menu-search-icon fa-regular fa-magnifying-glass"></i>
    }
    <input
      type="text"
      class="settings-menu-search-input"
      role="combobox"
      [attr.aria-controls]="$activeDescendant() ? 'menu-listbox' : null"
      [attr.aria-activedescendant]="$activeDescendantId()"
      [value]="$query()"
      (input)="onQueryInput($event)"
      (keydown)="onSearchKeydown($event)"
      [placeholder]="$search()?.placeholder ?? 'Search...'"
      [autofocusOnRender]="$search()?.autofocus ?? true"
    />
  </div>
}

<div class="settings-menu-list">
@for (item of $visibleItems(); track (item.type === 'divider' || item.type === 'compound' || item.type === 'group') ? $index : item.id) {

  @if (item.type !== 'divider' && item.type !== 'compound' && item.type !== 'group' && hasRenderer(item.type)) {
    <ng-container *ngTemplateOutlet="getRenderer(item.type); context: { $implicit: item }"></ng-container>
  } @else {

    <div class="settings-item-block" [attr.id]="rowId(item)" [class.is-active]="isHighlighted(item)" (mousedown)="onRowMousedown($event)">
      @switch (item.type) {
        @case ('divider') {
          <div class="settings-divider"></div>
        }
        @case ('group') {
          <div class="settings-group-header">{{ item.label }}</div>
        }
        @case ('navigate') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <button type="button" class="item-value-area item-value-clickable" [class.value-align-right]="item.valueAlign === 'right'" [disabled]="resolveVisibility(item.disabled)" (click)="onItemClick(item)">
              @let display = resolveDisplay(item);
              @if (display.preview?.icon) {
                <i class="item-value-icon" [class]="display.preview.icon" [attr.data-tone]="display.preview.tone"></i>
              }
              @if (display.text) { <span class="item-value-text">{{ display.text }}</span> }
              @if (!display.text && !display.preview && item.count !== undefined && item.count !== null) { <span class="item-value-text item-count">{{ item.count }}</span> }
              <i class="fa-regular fa-angle-right item-chevron"></i>
            </button>
          </div>
        }
        @case ('dropdown') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <wb-button-dropdown class="item-value-area item-value-dropdown" [formControl]="item.control" [commands]="getDropdownCommands(item)" [showCaret]="false" iconRight="fa-regular fa-angle-down" [iconRightColor]="'var(--local-sp-chevron-color)'" displayStyle="Tertiary" />
          </div>
        }
        @case ('switch') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <div class="item-value-area item-value-switch">
              <wb-button-switch [formControl]="item.control" />
            </div>
          </div>
        }
        @case ('input') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <div class="item-value-area item-value-input">
              <input type="text" class="item-input" [formControl]="item.control" [placeholder]="item.placeholder ?? ''" [autofocusOnRender]="item.autofocus ?? false" [readonly]="resolveVisibility(item.disabled)" [attr.tabindex]="resolveVisibility(item.disabled) ? -1 : null" />
            </div>
          </div>
        }
        @case ('iconPicker') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <div class="item-value-area item-value-icon-picker">
              <w-icon-picker [formControl]="item.control" [packs]="['fa6']" [placeholder]="item.placeholder ?? 'Pick an icon'" />
            </div>
          </div>
        }
        @case ('tonePicker') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <div class="item-value-area item-value-tone-picker">
              <wb-tone-picker [formControl]="item.control" [tones]="resolveTonePickerTones(item)" />
            </div>
          </div>
        }
        @case ('select') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <div class="item-value-area item-value-select">
              <wb-button-select [formControl]="item.control" [commands]="item.commands" [fullWidth]="true" />
            </div>
          </div>
        }
        @case ('tabs') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            @if (item.label) { <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span> }
            <div class="item-value-area item-value-tabs">
              <wb-button-tab [formControl]="item.control" [commands]="item.commands" [fullWidth]="true" [type]="$any(item).tabType ?? 'Button'" [size]="ButtonSize.Medium" />
            </div>
          </div>
        }
        @case ('entityPicker') {
          <div class="settings-item" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}@if (item.required) { <span class="item-required">*</span> }</span>
            <button type="button" class="item-value-area item-value-clickable" [class.value-align-right]="item.valueAlign === 'right'" [disabled]="resolveVisibility(item.disabled)" (click)="onItemClick(item)">
              @let display = resolveDisplay(item);
              @if (display.preview?.icon) {
                <i class="item-value-icon" [class]="display.preview.icon" [attr.data-tone]="display.preview.tone"></i>
              }
              @if (display.text) { <span class="item-value-text">{{ display.text }}</span> }
              <i class="fa-regular fa-angle-right item-chevron"></i>
            </button>
          </div>
        }
        @case ('compound') {
          <div class="settings-item settings-item-compound" [class.disabled]="resolveVisibility(item.disabled)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}</span>
            <div class="item-value-area item-value-compound">
              @for (child of item.items; track $index) {
                @switch (child.type) {
                  @case ('dropdown') {
                    <wb-button-dropdown class="item-value-area item-value-dropdown" [formControl]="child.control" [commands]="getDropdownCommands(child)" [showCaret]="false" iconRight="fa-regular fa-angle-down" [iconRightColor]="'var(--local-sp-chevron-color)'" displayStyle="Tertiary" />
                  }
                  @case ('select') {
                    <wb-button-select [formControl]="child.control" [commands]="child.commands" />
                  }
                  @case ('tabs') {
                    <wb-button-tab [formControl]="child.control" [commands]="child.commands" type="Button" />
                  }
                  @case ('switch') {
                    <wb-button-switch [formControl]="child.control" />
                  }
                  @case ('navigate') {
                    <button type="button" class="compound-navigate" [disabled]="resolveVisibility(child.disabled)" (click)="onItemClick(child)">
                      @let childDisplay = resolveDisplay(child);
                      @if (childDisplay.preview?.icon) {
                        <i class="item-value-icon" [class]="childDisplay.preview.icon" [attr.data-tone]="childDisplay.preview.tone"></i>
                      }
                      @if (childDisplay.text) { <span class="item-value-text">{{ childDisplay.text }}</span> }
                      <i class="fa-regular fa-angle-right item-chevron"></i>
                    </button>
                  }
                }
              }
            </div>
          </div>
        }
        @case ('inlineComponent') {
          <ng-container *ngComponentOutlet="$any(item).component; inputs: getInlineComponentInputs($any(item))"></ng-container>
        }
        @case ('action') {
          <button class="settings-item settings-item-action" [disabled]="resolveVisibility(item.disabled)" (click)="onItemClick(item)">
            @if (item.icon) { <i [class]="item.icon + ' item-icon'"></i> }
            <span class="item-label">{{ item.label }}</span>
          </button>
        }
        @default {
          <ng-container *ngTemplateOutlet="getRenderer($any(item).type); context: { $implicit: item }"></ng-container>
        }
      }

      @if (getErrorMessage(item); as errorMessage) {
        <div class="settings-item-error-row">
          <span class="settings-item-error-message">{{ errorMessage }}</span>
        </div>
      }
    </div>

  }
}
</div>

